// Treatments that must display an allergy warning line between the title
// and the short description, on the public catalogue row and in the
// treatment detail modal. Keyed by backend slug so renames of the display
// name won't silently drop the warning. Add new slugs to the appropriate
// set — nothing else to touch.
export const FISH_ALLERGY_SLUGS = new Set([
  "polynucleotides-course-of-3",
  "polynucleotides-face",
  "polynucleotides-face-eyes",
  "polynucleotides-under-eyes", // Lumi Eyes – Eye Rejuvenation
]);

export const FISH_ALLERGY_WARNING =
  "This treatment is not suitable for anyone with fish allergies.";

// Lemon Bottle products contain pineapple-derived enzymes.
export const PINEAPPLE_ALLERGY_SLUGS = new Set([
  "lemon-bottle-fat-dissolving",
  "lemon-bottle-skin-booster",
]);

export const PINEAPPLE_ALLERGY_WARNING =
  "This treatment is not suitable for anyone with pineapple allergies.";

export function fishAllergyWarningFor(treatment) {
  if (!treatment) return null;
  return FISH_ALLERGY_SLUGS.has(treatment.slug) ? FISH_ALLERGY_WARNING : null;
}

export function pineappleAllergyWarningFor(treatment) {
  if (!treatment) return null;
  return PINEAPPLE_ALLERGY_SLUGS.has(treatment.slug)
    ? PINEAPPLE_ALLERGY_WARNING
    : null;
}

// Generic resolver — returns the first matching allergy warning for a
// treatment, or null if none applies. Callers render it in the SAME
// styled <p> block so every allergy warning shares identical placement,
// typography, colour and responsive behaviour.
export function allergyWarningFor(treatment) {
  return (
    fishAllergyWarningFor(treatment) ||
    pineappleAllergyWarningFor(treatment)
  );
}
